import { createActions } from 'redux-actions';
const camelcase = require('camelcase');
import { generateKeyNames } from './keyAndPayloadName';
export class BaseActions {
    constructor(keyStartAndPayloadName) {
        this.keyStartAndPayloadName = keyStartAndPayloadName;
        this.buildSyncActions = this.buildSyncActions.bind(this);
        this.keyNames = generateKeyNames(this.keyStartAndPayloadName);
    }
    buildSyncActions() {
        this.syncActions = createActions({
            [this.keyNames.START]: () => { },
            [this.keyNames.SUCCESS]: (payload) => Array.isArray(payload) ? Object.assign([], payload) : Object.assign({}, payload),
            [this.keyNames.FAILURE]: (errors) => { return errors; }
        });
        return this.syncActions;
    }
    createAsyncAction(promise) {
        return (dispatch) => {
            dispatch(this.syncActions[camelcase(this.keyNames.START)]());
            return promise
                .then(response => {
                if (response) {
                    const action = this.syncActions[camelcase(this.keyNames.SUCCESS)](response);
                    dispatch(action);
                }
                else {
                    dispatch(this.syncActions[camelcase(this.keyNames.FAILURE)](null));
                }
            }).catch((e) => {
                // Bad request -> API says data is not valid
                if (e.status === 400) {
                    const errors = JSON.parse(e.response);
                    dispatch(this.syncActions[camelcase(this.keyNames.FAILURE)](errors));
                }
                else if (e.status === 403) {
                    e.response = "Du har ikke tilladelse til at se denne del af hjemmesiden.";
                    dispatch({ type: 'ADD_ERROR', payload: e });
                }
                else if (e.status === 404) {
                    e.response = "Ressourcen kunne ikke findes i systemet.";
                    dispatch({ type: 'ADD_ERROR', payload: e });
                }
                else if (e.status === 500) {
                    dispatch(this.syncActions[camelcase(this.keyNames.FAILURE)](e));
                    dispatch({ type: 'ADD_ERROR', payload: e });
                }
                else {
                    //const error = "Der opstod en ukendt fejl i systemet.";
                    const error = "";
                    dispatch(this.syncActions[camelcase(this.keyNames.FAILURE)](error));
                    dispatch({ type: 'ADD_ERROR', payload: error });
                }
            });
        };
    }
}
